import { memo } from 'react';

import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';

import { uiImages } from '@/react/components/content/registry/data';

/**
 * Register the BureauOfAdventure one-off component.
 */
const register = (): void => {
  Builder.registerComponent(memo(dynamic(() => import('./index'))), {
    name: 'BureauOfAdventure',
    image: uiImages.cubeImage,
    noWrap: true,
    inputs: []
  });
};

export default register;
